import { useEffect, useState } from "react";
const moment = require("moment-timezone");
const live_events_service = require("../../../../helpers/live_events_service");
const useCountdown = (targetDate) => {
  const countDownDate = moment(targetDate)
  const [countDown, setCountDown] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      live_events_service
        .getData("/time-helpers/get-now")
        .then((data_now) => {
          setCountDown(
            countDownDate.diff(
              moment(
                data_now.data.response.result[0].ahora,
                "YYYY-MM-DD HH:mm:ss"
              ).tz("America/Guatemala"),
              "milliseconds"
            )
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }, 1000);

    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
};

const getReturnValues = (countDown) => {
  const totalSeconds = Math.floor(countDown / 1000);
  const totalMinutes = Math.floor(totalSeconds / 60);
  const totalHours = Math.floor(totalMinutes / 60);
  const totalDays = Math.floor(totalHours / 24);

  const months = Math.floor(totalDays / 30); // Approximate: 1 month = 30 days
  const days = totalDays % 30;
  const hours = totalHours % 24;
  const minutes = totalMinutes % 60;
  const seconds = totalSeconds % 60;

  return [months, days, hours, minutes, seconds];
};



export { useCountdown };
